import g1 from '@/assets/v2/galeria/g1-grupo.webp';
import g2 from '@/assets/v2/galeria/g2-turma.webp';
import g3 from '@/assets/v2/galeria/g3-camisetas.webp';
import g4 from '@/assets/v2/galeria/g4-mural.webp';
import g5 from '@/assets/v2/galeria/g5-conversa.webp';
import g6 from '@/assets/v2/galeria/g6-abraco.webp';
import g7 from '@/assets/v2/galeria/g7-clube.webp';
import Reveal from '@/components/v2/primitives/Reveal';
import { HUE_MARCA } from '@/design/hues';

/**
 * As fotos do clube.
 *
 * Elas já existiam — estavam achatadas dentro dos três arquivos do
 * carrossel antigo, junto com texto impresso por cima. Aqui cada uma é
 * um arquivo próprio, com alt de verdade.
 *
 * São sete e não oito de propósito: em quatro colunas, a primeira
 * ocupando duas, sete preenchem as duas fileiras exatamente. Com oito
 * sobrava um buraco.
 */
const FOTOS = [
  { src: g1, alt: 'Grupo do clube reunido no encontro', larga: true },
  { src: g2, alt: 'Integrantes do clube reunidas em pé' },
  { src: g3, alt: 'Duas leitoras com camisetas do clube' },
  { src: g4, alt: 'Quatro leitoras em frente ao mural' },
  { src: g5, alt: 'Três leitoras conversando' },
  { src: g6, alt: 'Duas leitoras abraçadas sorrindo' },
  { src: g7, alt: 'Grupo com as camisetas do clube' },
];

export const Galeria = () => (
  <section data-hue={HUE_MARCA} className="banda-rosa">
    <div className="mx-auto w-full max-w-[1100px] px-5 py-14 md:px-6 md:py-20">
      <Reveal>
        <h2 className="type-club mb-3 text-[clamp(34px,6.4vw,76px)] text-[var(--banda-titulo)]">
          O Clube
        </h2>
        <p className="mb-9 max-w-[52ch] text-[clamp(15.5px,1.8vw,18px)] opacity-85">
          Um encontro por mês, em Manaus, entre quem leu o mesmo livro.
        </p>

        <ul className="grid list-none grid-cols-2 gap-3 p-0 md:grid-cols-4 md:gap-3.5">
          {FOTOS.map((foto) => (
            <li
              key={foto.src}
              className={`overflow-hidden bg-[color-mix(in_srgb,var(--banda-titulo)_18%,transparent)] ${
                foto.larga ? 'col-span-2 aspect-[2.07/1]' : 'aspect-square'
              }`}
            >
              <img
                src={foto.src}
                alt={foto.alt}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] hover:scale-[1.06]"
              />
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);

export default Galeria;
